import { FunctionComponent } from 'react'
import styles from './unlinkAdminDialog.module.scss'
import DialogHeader from '@/components/_custom/DialogHeader/DialogHeader'
import DialogBody from '@/components/_custom/DialogBody/DialogBody'
import ButtonTextIcon from '@/components/_custom/Buttons/ButtonTextIcon/ButtonTextIcon'
import { Close, Delete } from '@mui/icons-material'
import Dialog from '@/components/_custom/Dialog/Dialog'
import { useTranslation } from 'react-i18next'
import { useMutation } from '@apollo/client'
import { UNLINK_TRUSTEE } from '@/modules/API/daycareGroup/trusteeLinkHandler'
import { useNotification } from '@/modules/context/NotificationContext.tsx'

interface UnlinkAdminDialogProps {
    open: boolean
    handleClose: () => void
    groupId: number
    trusteeId: number
    refetchGroups: () => void
}

const UnlinkAdminDialog: FunctionComponent<UnlinkAdminDialogProps> = ({
    open,
    handleClose,
    groupId,
    trusteeId,
    refetchGroups
}: UnlinkAdminDialogProps) => {
    const { t } = useTranslation()

    const { showNotificationSuccess, showNotificationError } = useNotification()

    const [deleteTrustee] = useMutation(UNLINK_TRUSTEE, {
        variables: {
            groupId: groupId,
            trusteeId: trusteeId
        },
        onCompleted: () => {
            showNotificationSuccess(t('adminUnlinked'))

            refetchGroups()
            handleClose()
        },
        onError: () => {
            showNotificationError(t('adminUnlinkedError'))

            handleClose()
        }
    })

    return (
        <Dialog open={open} handleClose={handleClose} className={styles.Dialog}>
            <DialogHeader title={t('confirmUnlinkAdmin')} />
            <DialogBody className={styles.DialogBody}>
                <p className={styles.Text}>{t('confirmUnlinkAdminMessage')}</p>
                <p className={styles.Text}>{t('noRollBack')}</p>
                <div className={styles.ButtonContainer}>
                    <ButtonTextIcon
                        type={'custom'}
                        customText={t('yes')}
                        customIcon={<Delete />}
                        onClick={deleteTrustee}
                        className={styles.Button}
                    />
                    <ButtonTextIcon
                        type={'custom'}
                        customText={t('no')}
                        customIcon={<Close />}
                        onClick={handleClose}
                        className={styles.Button}
                    />
                </div>
            </DialogBody>
        </Dialog>
    )
}

export default UnlinkAdminDialog
